var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Divider } from "@mui/material";
var VerticalDivider = function (_a) {
    var sx = _a.sx;
    return (_jsx(Divider, { orientation: "vertical", sx: __assign({ flexShrink: 0, backgroundColor: "rgba(255, 255, 255, 0.1)", width: "1px", height: "24px", display: { xs: "none", md: "block" } }, sx) }));
};
export default VerticalDivider;
